// extracted by mini-css-extract-plugin
export default {"scrollDown":"ScrollDownArrow_scrollDown__fXJtD","bounce":"ScrollDownArrow_bounce__TqtR1","arrow":"ScrollDownArrow_arrow__2+++u"};